import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LESSON_FEATURE_KEY } from './keys';
import { lessonReducer } from './reducers/lesson.reducer';
import { LessonEffects } from './effects/lesson.effects';

export const lessonStoreProviders = [provideState(LESSON_FEATURE_KEY, lessonReducer), provideEffects(LessonEffects)];

export { LessonFacade } from './facades/lesson.facade';
export * from './models';
export { lessonActions } from './actions/lesson.actions';
